// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.vendorsandpartners.insurancecompanies.practiceinsuranceremittancecodeadjustment.UpdatePracticeInsuranceRemittanceCodeAdjustmentRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePracticeInsuranceRemittanceCodeAdjustmentRequest extends GandalfModelBase {

	@GandalfLabel('Adjustment Reason')
	@GandalfValidator({ notNull: { message: 'Adjustment Reason is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	accountingAdjustmentReasonId!: number;

	@GandalfConstantDecorator(constants.PaymentTransferMethodType)
	@GandalfLabel('Transfer Type')
	@GandalfValidator({ notNull: { message: 'Transfer Type is required' } })
	@GandalfProperty({ designType: constants.PaymentTransferMethodType, isRequired: true })
	autoPostingAdjustmentType!: constants.PaymentTransferMethodType;

	@GandalfLabel('Description')
	@GandalfValidator({ sizeString: { message: 'Description cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfConstantDecorator(constants.RemittanceAdjustmentGroupCode)
	@GandalfLabel('Group Code')
	@GandalfProperty({ designType: constants.RemittanceAdjustmentGroupCode })
	groupCode!: constants.RemittanceAdjustmentGroupCode | null;

	@GandalfLabel('practiceInsuranceRemittanceCodeAdjustmentId')
	@GandalfValidator({ notNull: { message: 'practiceInsuranceRemittanceCodeAdjustmentId is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceInsuranceRemittanceCodeAdjustmentId!: number;

	@GandalfLabel('Adjustment Code')
	@GandalfValidator({ notNull: { message: 'Adjustment Code is required' } })
	@GandalfValidator({ sizeString: { message: 'Adjustment Code must be between 1 and 20 characters', minLength: 1, maxLength: 20 } })
	@GandalfProperty({ designType: String, isRequired: true })
	x12Code!: string;

}
